module.exports = __webpack_public_path__ + "img/nz.nz0dcf8cf.svg";